export enum ILocalStoreKey {
  merchantFormData = 'merchantFormData',
  processorData = 'processorData',
  loginQueryParamsData = 'loginQueryParamsData',
}

export interface IMerchantData {
  current: number;
  data: any[];
}

export type IProcessorData = IMerchantData;
